import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function AddNewTaskServices(token,data) {
    return axios.post(`${CURRENT_API_URL}/swinternalsystem/addNewTask`, data,{
    headers: {
        'Authorization': token,
    }
    }).then(res => {
        notify.NotifySuccess("New task  added successfully. Thank You!");       
        return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while adding new task. please try again later.");
        return false;
    });
}

export default AddNewTaskServices;